import React from "react";
import { Switch, Route } from "react-router-dom";
import { combineReducers } from "redux";

// Components
import ErrorLog from "./ErrorLog";
import TableView from './TableView'
// import RestClient from './RestClient';
import IntegrityCheck from "./IntegrityCheck";
// import ReportFinder from "./ReportFinder";
import ReportFinderCreate from "./ReportFinder/ReportFinderCreate";
import Translate from "../sc-translate/Translate";
import Permission from './Permission';
import PermissionEdit from '../np-core/Permissions/PermissionEdit';
import PermissionCreate from '../np-core/Permissions/PermissionCreate';
import GradingCategory from './GradingCategory';
import SentMail from './SentMail';
import ErasureMethod from './ErasureMethod';

// Reducers
import errorLogReducer from "./ErrorLog/store/errorLogReducer";
import tableViewReducer from './TableView/store/tableViewReducer';
import restClientReducer from "./RestClient/store/restClientReducer";
import deliveryNotesReducer from "./DeliveryNotes/store/deliveryNotesReducer";
import integrityCheckReducer from "./IntegrityCheck/store/integrityCheckReducer";
import permissionReducer from './Permission/store/permissionReducer';
import productTypeReducer from './ProductType/store/productTypeReducer';
import deviceDependentSettingReducer from './DeviceDependentSetting/store/deviceDependentSettingReducer';
import systemCertificateReducer from './SystemCertificate/store/systemCertificateReducer';
import userReducer from './UserAdminSettings/User/store/userReducer';

// import Mail from './Mail';
import DeviceDependentSetting from './DeviceDependentSetting';
import DeviceDependentSettingCreate from './DeviceDependentSetting/DeviceDependentSettingCreate';
import DeviceDependentSettingEdit from './DeviceDependentSetting/DeviceDependentSettingEdit';
import DeviceDependentSettingCreateFromThis from './DeviceDependentSetting/DeviceDependentSettingCreateFromThis';

import supportedClientTypeReducer from './SupportedClientType/store/supportedClientTypeReducer';
import gradingCategoryReducer from "./GradingCategory/store/gradingCategoryReducer";
import sentMailReducer from "./SentMail/store/sentMailReducer";
import erasureMethodReducer from "./ErasureMethod/store/erasureMethodReducer";
import Customer from "../sc-customer/Customer";
import UserAdminSettings from './UserAdminSettings/User';
import SystemCertificate from "./SystemCertificate";

import { hasPermission } from "../sc-utilities";

import SecurazeSolution from "./SecurazeSolution";
import ClientVersionsCheck from "./ClientVersionsCheck";
import AdminDiagnoseCase from "./AdminDiagnoseCase";

import DeviceCaseSupported from './DeviceCaseSupported';

// Routes
export const routes = (basePath, permissions) =>
    <Switch>
        {hasPermission('error_log_list', permissions) && <Route path={basePath + "/errorLogs"} exact component={ErrorLog} />}
        {/* {<Route path={basePath + '/rest'} exact component={RestClient} />} */}
        {hasPermission('table_view_list', permissions) && <Route path={basePath + "/tableView"} exact component={TableView} />}
        {hasPermission('report_finder_create', permissions) && <Route path={basePath + "/reportFinderCreate"} component={ReportFinderCreate} />}
        {hasPermission('integrity_check_list', permissions) && <Route path={basePath + "/integrityChecks"} exact component={IntegrityCheck} />}
        {hasPermission('translation_list', permissions) && <Route path={basePath + "/translate"} exact component={Translate} />}
        {hasPermission('permission_list', permissions) && <Route path={basePath + '/permissions'} exact component={Permission} />}{' '}
        {hasPermission('device_dependent_setting_list', permissions) && <Route path={basePath + '/deviceDependentSettings'} component={DeviceDependentSetting} />}
        {hasPermission('device_dependent_setting_create', permissions) && <Route path={basePath + '/deviceDependentSettingsCreate'} component={DeviceDependentSettingCreate} />}
        {hasPermission('device_dependent_setting_save', permissions) && <Route path={basePath + '/deviceDependentSettingsEdit'} component={DeviceDependentSettingEdit} />}
        {hasPermission('device_dependent_setting_create', permissions) && <Route path={basePath + '/deviceDependentSettingsCreateFromThis'} component={DeviceDependentSettingCreateFromThis} />}
        {hasPermission('permission_create', permissions) && <Route path={'/permissions/create'} component={PermissionCreate} />}
        {hasPermission('permission_save', permissions) && <Route path={'/permissions/:id/edit'} component={PermissionEdit} />}
        {hasPermission('grading_category_list', permissions) && <Route path={basePath + "/grade-category"} exact component={GradingCategory} />}
        {hasPermission('sent_mail_list', permissions) && <Route path={basePath + "/sentMail"} exact component={SentMail} />}
        {hasPermission('erasure_method_list', permissions) && <Route path={basePath + "/erasureMethod"} exact component={ErasureMethod} />}
        {hasPermission('customer_list', permissions) && <Route path={basePath + "/customers"} exact component={Customer} />}
        {hasPermission('users_admin_settings', permissions) && <Route path={basePath + "/usersAdminSettings"} exact component={UserAdminSettings} />}
        {hasPermission('system_certificate_list', permissions) && <Route path={basePath + "/system-certificate"} exact component={SystemCertificate} />}
        {hasPermission('securaze_solution_list', permissions) && <Route path={basePath + "/securaze-solution"} exact component={SecurazeSolution} />}
        {hasPermission('client_type_usage', permissions) && <Route path={basePath + "/client-types-usage"} exact component={ClientVersionsCheck} />}
        {hasPermission('device_case_supported_list', permissions) && <Route path={basePath + '/device-case-supported'} component={DeviceCaseSupported} />}
        {hasPermission('diagnose_case_list', permissions) && <Route path={basePath + "/diagnose-case"} exact component={AdminDiagnoseCase} />}
    </Switch>

export const subComponents = (translations) => [
    { name: translations["supported_client_types"] || "Supported client types", path: '/supported-client-types', permissions: ['supported_client_type'] },
    { name: translations["client_type_usage"] || "Client type usage", path: '/client-types-usage', permissions: ['client_type_usage'] },
    { name: translations["device_dependent_settings"] || "Device dependent settings", path: '/deviceDependentSettings', permissions: ['device_dependent_setting_list'] },
    { name: translations["notification_settings"] || "Notification settings", path: '/notificationSettings', permissions: ['notification_settings_list'] },
    { name: translations["error_logs"] || "Error Logs", path: "/errorLogs", permissions: ["error_log_list"] },
    { name: translations["table_view"] || "Table View", path: "/tableView", permissions: ["table_view_list"] },
    // { name: 'Rest Client', path: '/rest', permissions: [] },
    { name: translations["integrity_checks"] || "Integrity checks", path: "/integrityChecks", permissions: ["integrity_check_list"] },
    { name: translations["translations"] || "Translations", path: "/translate", permissions: ["translation_list"] },
    { name: translations["permissions"] || "Permissions", path: "/permissions", permissions: ["permission_list"] },
    { name: translations["import_data_from"] || "Import data from", path: '/securaze-cloud-data', permissions: ['securaze_cloud_data_list'] },
    { name: translations["import_data_old"] || "Import data from old", path: '/old-securaze-data', permissions: ['old_securaze_data_list'] },
    { name: translations["product_type"] || "Product type", path: '/product-type', permissions: ['product_type_list'] },
    { name: translations["grading_category"] || "Grading category", path: "/grade-category", permissions: ["grading_category_list"] },
    { name: translations["sent_mail"] || "Sent mail", path: "/sentMail", permissions: ["sent_mail_list"] },
    { name: translations["securaze_standard"] || "Securaze Standard", path: "/erasureMethod", permissions: ["erasure_method_list"] },
    { name: translations["servers"] || "Servers", permissions: ["server_list"], path: "/servers", },
    { name: translations["customers"] || "Customer", path: '/customers', permissions: ['customer_list'] },
    { name: translations["users"] || "Users", path: '/adminSettingsUsers', permissions: ['users_admin_settings'] },
    { name: translations["system_certificate"] || "System Certificate", path: '/system-certificate', permissions: ['system_certificate_list'] },
    { name: translations["securaze_solutions"] || "Securaze Solutions", path: '/securaze-solution', permissions: ['securaze_solution_list'] },
    { name: translations["diagnose_cases"] || "Diagnose cases", path: '/diagnose-case', permissions: ['diagnose_case_list'] },
    { name: translations["device_case_supported"] || "Device case supported", path: '/device-case-supported', permissions: ['device_case_supported_list'] },
    { name: translations["device_case_preselection"] || "Device case preselection", path: '/device-case-preselection', permissions: ['devise_case_preselection_list'] },
];

export const reducers = combineReducers({
    errorLog: errorLogReducer,
    restClient: restClientReducer,
    deliveryNotes: deliveryNotesReducer,
    integrityCheck: integrityCheckReducer,
    systemCertificate: systemCertificateReducer,
    permission: permissionReducer,
    productType: productTypeReducer,
    deviceDependentSettings: deviceDependentSettingReducer,
    supportedClientType: supportedClientTypeReducer,
    gradingCategory: gradingCategoryReducer,
    sentMail: sentMailReducer,
    tableView: tableViewReducer,
    erasureMethod: erasureMethodReducer,
    users: userReducer
});
